import { z } from "zod";

import { BackendEntityType } from "./AttachmentModel";
import { baseCreateType } from "./CreateTypes";
import { InvitationStatus } from "./Invitation";
import { mediaModelResolver } from "./MediaModel";

export enum WaiverFormat {
	file = "FILE",
	externalLink = "EXTERNAL_LINK"
}

export enum WaiverTypes {
	SOCCER_COMPETITION_PLAYER = "waiver.soccer.competition.player",
	SOCCER_COMPETITION_CLUB = "waiver.soccer.competition.club"
}

export const waiverFileResolver = z.object({
	id: z.string(),
	variants: mediaModelResolver.array()
});

export type WaiverFileModel = z.infer<typeof waiverFileResolver>;

export const waiverResolver = baseCreateType.pick({ id: true }).extend({
	dueDate: z.string().nullable(),
	entityId: z.string(),
	entityType: z.nativeEnum(BackendEntityType),
	format: z.nativeEnum(WaiverFormat),
	link: z.string().nullable(),
	status: z.nativeEnum(InvitationStatus),
	title: z.string(),
	type: z.nativeEnum(WaiverTypes),
	file: waiverFileResolver.nullable().or(z.string().nullable()),
	signatureStats: z
		.object({
			signed: z.number(),
			pending: z.number(),
			total: z.number()
		})
		.optional()
});

export type WaiverModel = z.infer<typeof waiverResolver>;

export const waiverSignatureResolver = baseCreateType.pick({ id: true }).extend({
	status: z.nativeEnum(InvitationStatus),
	waiver: waiverResolver
});

export type WaiverSignatureModel = z.infer<typeof waiverSignatureResolver>;
